module.exports = __webpack_public_path__ + "img/placeholder-gray-square.2c8f54bc.svg";